import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

export default function LeaveReceivingAssistantModal({
  onClose,
  onContinue,
  onSaveProgress,
  onDelete,
  canDelete,
}) {
  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{ px: 6, pt: 3, textAlign: "center", fontSize: 22, fontWeight: 500, color: "common.black" }}
      >
        Leave Receiving Assistant?
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", right: 12, top: 12, color: "text.secondary" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography align="center" color="text.secondary">
          You haven't finished receiving this shipment yet. Save your progress to pick up where
          you left off
          {canDelete ? ", or delete the shipment if you no longer need it" : ""}.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, flexDirection: "column", alignItems: "stretch", gap: 1.5 }}>
        <Box display="flex" gap={1.5}>
          <Button onClick={onSaveProgress} variant="outlined" fullWidth>
            Save Current Progress
          </Button>
          <Button onClick={onContinue} variant="contained" fullWidth>
            Continue Receiving
          </Button>
        </Box>
        {canDelete && (
          <Button onClick={onDelete} color="error" size="small" sx={{ alignSelf: "center" }}>
            Delete Shipment
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
